import { render, staticRenderFns } from "./MethodologyView.vue?vue&type=template&id=39a45df4&"
import script from "./MethodologyView.vue?vue&type=script&lang=ts&"
export * from "./MethodologyView.vue?vue&type=script&lang=ts&"
import style0 from "./MethodologyView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports